/**
 * Leads list controller: same flow as the customers list, with the
 * end users API filtered on userType = 'lead'.
 */
define('customersLeadsListController',[
  'module',
  'underscore',
  'app',
  'settings',
  'customersListController',
  'customersLeadsListView',
  'entities/customers/customers'
], function (
  module,
  _,
  App,
  Settings,
  CustomersListController,
  View
) {
  'use strict';

  var LeadsListController = _.extend({}, CustomersListController, {
    showLeadsList: function () {
      this.showCustomersList();
    },

    onGridLoaded: function () {
      var data = {
        url: App.request('customers:get-url', true),
        rowCountUrl: App.request('customers:row-count-url', true)
      };

      this.view.displayGrid(data, true);
    },

    _showView: function (countries) {
      var view = new View({
        countries: countries
      });

      this.view = view;

      view.listenTo(view, 'customers:import-excel', _.bind(this.onImportExel, this));
      view.listenTo(view, 'customers:import-excel-contacts', _.bind(this.onImportExcelContacts, this));
      view.listenTo(view, 'customers:remove', _.bind(this.onDelete, this));
      view.listenTo(view, 'onGridLoaded', _.bind(this.onGridLoaded, this));
      App.regions.getRegion('main').currentView.getRegion('content').show(view);

      view.ui.exportBtn.attr('href', Settings.url('compuzz2', 'endusers.json/excel', {userType: 'lead'}));
    }
  });

  module.exports = LeadsListController;
});

